import { router } from "@inertiajs/react"
import { Sparkles, Trash2, X } from "lucide-react"
import { toast } from "sonner"

import { Button } from "@/components/ui/button"
import type { QualityUrls } from "@/lib/types"

interface Props {
  count: number
  selectedIds: number[]
  urls: QualityUrls
  onClear: () => void
}

export function BatchActionsBar({ count, selectedIds, urls, onClear }: Props) {
  const handleDismiss = () => {
    router.post(
      urls.batch_action,
      { action_type: "dismiss", issue_ids: selectedIds },
      {
        preserveScroll: true,
        onSuccess: () => {
          onClear()
          toast(`${count} ${count === 1 ? "issue" : "issues"} dismissed`)
        },
      },
    )
  }

  const handleEnrich = () => {
    router.post(
      urls.request_enrichment,
      { issue_ids: selectedIds },
      {
        preserveScroll: true,
        onSuccess: () => {
          onClear()
          toast("Enrichment queued", {
            description: "Proposals will appear here once Claude responds.",
          })
        },
      },
    )
  }

  return (
    <div
      className="fixed inset-x-0 bottom-4 z-20 mx-auto flex w-fit max-w-[95vw] items-center gap-3 rounded-full border bg-popover px-4 py-2 shadow-lg"
      role="region"
      aria-live="polite"
      aria-label={`${count} ${count === 1 ? "issue" : "issues"} selected`}
    >
      <span className="text-sm font-medium tabular-nums">
        {count} selected
      </span>

      <div className="h-4 w-px bg-border" aria-hidden />

      <Button size="sm" variant="ghost" onClick={handleDismiss} className="min-h-9">
        <Trash2 className="mr-1 size-3.5" aria-hidden />
        Dismiss selected
      </Button>

      <Button size="sm" variant="outline" onClick={handleEnrich} className="min-h-9">
        <Sparkles className="mr-1 size-3.5" aria-hidden />
        Enrich metadata
      </Button>

      <Button
        size="sm"
        variant="ghost"
        onClick={onClear}
        aria-label="Clear selection"
        className="size-9 p-0"
      >
        <X className="size-4" aria-hidden />
      </Button>
    </div>
  )
}
